import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import cn from 'classnames';
import { Button } from 'ui/components';

import { Job, Manifest } from 'services/action';

import { ShippingDetails, FormLand, Submit } from './index';

const initialState = {
  step: 1,
  method: '',
  detail: null,
  details: null,
  moda: null,
  job: null,
  errors: null,
  loading: false,
};

const DispatchForm = ({ data, onCreate }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ step, method, detail, moda, job, errors, loading }, setState] =
    React.useState(initialState);

  const nextStep = () => {
    setState((prevState) => ({ ...prevState, step: step + 1 }));
  };

  const prevStep = () => {
    setState((prevState) => ({ ...prevState, step: step - 1 }));
  };

  const $handleModaChange = (v) => {
    setState((prevState) => ({ ...prevState, moda: v }));
  };

  const $loadJob = async (e) => {
    const req = await Dispatch(Job.$getJobByOrder(e));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, job: req?.data }));
    }
  };

  const onSubmit = async () => {
    const payload = {
      shipping_method: method,
      schedule_at: detail?.schedule?.formatted,
      vendor_id: detail?.vendor?.id,
      origin_id: detail?.origin?.id,
      total_cost: detail?.total_cost,
    };

    let items = [];

    if (job !== null) {
      job?.forEach((item) => {
        if (item?.type === 'last_mile') {
          items.push({
            job_id: item?.id,
          });
        }
      });
    }

    if (items) {
      payload.jobs = items;
    }

    payload.shipping_method = 'inhouse';
    payload.moda_type = 'land_freight';
    payload.type = 'last_mile';
    payload.land_freight = {
      driver_id: moda?.driver_id,
      vehicle_id: moda?.vehicle?.id,
      vehicle_type_id: moda?.vehicle_type?.id,
      name: moda?.name,
      phone_number: moda?.phone_number,
      vehicle_number: moda?.vehicle_number,
      bank_account: moda?.bank_account,
    };

    const req = await Dispatch(Manifest.$createTrucking(payload));

    if (req?.message === 'success') {
      onCreate();
    }
  };

  const validasi = async () => {
    let error = {};

    if (!detail?.schedule?.default) {
      error.schedule = 'Jadwal harus diisi';
    }

    if (!detail?.origin) {
      error.origin = 'Origin harus diisi';
    }

    if (!moda?.name) {
      error.name = 'Nama driver harus diisi';
    }
    if (!moda?.phone_number) {
      error.phone_number = 'No. handphone harus diisi';
    }
    if (!moda?.vehicle_number) {
      error.vehicle_number = 'No. polisi harus diisi';
    }

    if (!moda?.vehicle_type && !moda?.vehicle) {
      error.vehicle_type = 'Jenis kendaraan harus diisi';
      error.vehicle = 'Kendaraan harus diisi';
    }

    setState((prevState) => ({ ...prevState, loading: true }));

    setState((prevState) => ({ ...prevState, errors: error }));

    if (_.isEmpty(error)) {
      setTimeout(() => {
        nextStep();
        setState((prevState) => ({ ...prevState, loading: false }));
      }, 4000);
    } else {
      setTimeout(() => {
        setState((prevState) => ({ ...prevState, loading: false }));
      }, 2000);
    }
  };

  React.useEffect(() => {
    if (!data) return;
    $loadJob(data?.id);
  }, [data]);

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        errors: null,
      }));
    }, 2000);
  }, [errors]);

  switch (step) {
    case 1:
      return (
        <div>
          <ShippingDetails
            method={method}
            onValueChange={(e) =>
              setState((prevState) => ({ ...prevState, detail: e }))
            }
            errors={errors}
          />

          <div className="hr" />
          <FormLand
            onValueChange={$handleModaChange}
            vendor={detail?.vendor?.id}
            errors={errors}
          />

          <div className="d-flex gap-2 justify-content-end mt-3">
            {/* <button
              type="button"
              className={cn(
                'btn btn-sm btn-primary rounded',
                loading ? 'btn-loading' : ''
              )}
              disabled={loading}
              onClick={prevStep}
            >
              sebelumnya
            </button> */}

            <Button
              type="button"
              className={cn(
                'btn-primary py-md-2',
                loading ? 'btn-loading' : ''
              )}
              disabled={loading}
              onClick={validasi}
            >
              Selanjutnya
            </Button>
            {/* <button
              type="button"
              className={cn(
                'btn btn-sm btn-primary rounded',
                loading ? 'btn-loading' : ''
              )}
              disabled={loading}
              onClick={validasi}
            >
              Selanjutnya
            </button> */}
          </div>
        </div>
      );
    case 2:
      return (
        <div>
          <Submit detail={detail} moda={moda} />

          <div className="d-flex gap-2 justify-content-center mt-3">
            <Button
              type="button"
              className={cn(
                'btn-secondary py-md-2',
                loading ? 'btn-loading' : ''
              )}
              disabled={loading}
              onClick={prevStep}
            >
              Sebelumnya
            </Button>
            <Button
              type="button"
              className="btn-primary py-md-2"
              onClick={onSubmit}
              loading={StateForm?.loading}
            >
              Dispatch
            </Button>
          </div>
        </div>
      );
    default:
  }
};

export default DispatchForm;
